import { useState, useEffect, use } from "react";
import { Link, useNavigate, useSearchParams } from "react-router-dom";
import Navbar from "../../components/feature/Navbar";
import Footer from "../../components/feature/Footer";

import {
  addToCart,
  getCart,
  isInCart,
  updateCartItemQuantity,
  getCartQuantity,
} from "../../utils/cart";

import {
  BaseUrl,
  AUTH_KEY,
  apiUrl_dialerp,
  subID,
  Appname,
  setLogindata,
  setUserdata,
  LoggedInUserID,
  LoggedInUserName,
  Authorization_Token,
  staticToken,
} from "../../Services/Urls";
import { makeApiRequest, callApi } from "../../Services/ApiService";

import { getRecords, PostRecords } from "../../Services/ApiCall";
import { decryptOtp } from "../../Services/Helper";

import { useContext } from "react";
import { ApiContext } from "../../Context/Context";

export default function ProductsPage_new() {
  const navigate = useNavigate();
  const context = useContext(ApiContext);

  if (!context) {
    throw new Error("useApiContext must be used within a ApiContextProvider");
  }

  const { logindata, setlogindata, userData, setuserData } = context;

  const [searchParams] = useSearchParams();
  const [selectedCategory, setSelectedCategory] = useState<any>(null);
  const [sortBy, setSortBy] = useState("featured");
  const [notification, setNotification] = useState("");
  const [isCategoryDrawerOpen, setIsCategoryDrawerOpen] = useState(false);

  const [loading, setLoading] = useState(true);
  const [quantities, setQuantities] = useState<{ [key: number]: number }>({});
  const [Categories, setCategories] = useState<any[]>([]);
  const [items, setItems] = useState<any[]>([]);
  const [ItemMasterData, setItemMasterData] = useState<any[]>([]);

  useEffect(() => {
    getCategory();

    window.scrollTo(0, 0);
    // getItems();
    // const category = searchParams.get('category');
    // if (category) {
    //   setSelectedCategory(category);
    // }
  }, []);

  useEffect(() => {
    const cart = getCart();
    const qtyMap: { [key: number]: number } = {};

    cart.forEach((item: any) => {
      qtyMap[item.ItemID] = item.Qty;
    });

    setQuantities(qtyMap);

    if (isCategoryDrawerOpen) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "unset";
    }
    return () => {
      document.body.style.overflow = "unset";
    };
  }, [isCategoryDrawerOpen]);

  useEffect(() => {
    if (selectedCategory !== null) {
      getItems(selectedCategory);
    } else {
      getItems(null);
    }

    // const category = searchParams.get('category');
    // if (category) {
    //   setSelectedCategory(category);
    // }
  }, [selectedCategory]);

  const getCategory = () => {
    const PriceID = localStorage.getItem("UserData-UniversalDairy")
      ? JSON.parse(localStorage.getItem("UserData-UniversalDairy") || "{}")
          .ContractID
      : 1;

    let Url = `${BaseUrl}/api/Dynamic/GetRecords?tabErpID=${1481}&tabName=Sub%20Category`;

    const CategoryBody = {
      PriceContractID: PriceID,
      apiType: 1,
      filters: "{'PublishID':1}",
      index: 1,
      order: "1",
      orderBy: "SeqNo*",
      pgSize: 200,
      tabErpID: "1481",
      toEmailID: "",
      useAtlusSearch: "false",
      viewFormat: "columnname",
    };

    callApi(
      Url,
      CategoryBody,
      Authorization_Token ? Authorization_Token : staticToken,
      (data: any) => {
        if (data != null) {
          if (data?.hasErrors === false) {
            const filteredData = data?.response?.records.filter(
              (category: any) => category.ItemsCount > 0,
            );
            setCategories(filteredData || []);
            //setSelectedCategory(filteredData[0] || null);
            setLoading(false);
          } else {
            setLoading(false);
            console.log("Error in fetching categories", data);
          }
        } else {
          setLoading(false);
        }
      },
      (error: any) => {
        setLoading(false);
      },
    );
  };

  const getdataformItemMaster = (ids: any) => {
    getRecords(1478, 100, -1, `{ItemID: { $in: [${ids}] }}`, 1, "", (data) => {
      // console.log("user details response", response);

      if (data != null) {
        if (data?.hasErrors === false) {
          setItemMasterData(data?.response?.records || []);

          setLoading(false);
        } else {
          setLoading(false);
          console.log("Error in fetching categories", data);
        }
      } else {
        setLoading(false);
      }
    });
  };

  const getItems = (selectedCategory?: any) => {
    const PriceID = localStorage.getItem("UserData-UniversalDairy")
      ? JSON.parse(localStorage.getItem("UserData-UniversalDairy") || "{}")
          .ContractID
      : 1;
    let Url = `${BaseUrl}/api/Dynamic/GetRecords?tabErpID=${3323}&tabName=Sub%20Category`;
    const today = new Date();
    const start = new Date(today.setHours(0, 0, 0, 0)).toISOString();
    const end = new Date(today.setHours(23, 59, 59, 999)).toISOString();
    const itemBody = {
      pgSize: 10000,
      viewFormat: "columnname",
      filterButtons: "",
      index: 1,
      toEmailID: "admin@dialerp.com",
      tabErpID: 3323,
      useAtlusSearch: false,
      RoleID: 0,
      LedgerID: LoggedInUserID ? LoggedInUserID : 1002, // replace with your actual variable
      order: -1,
      orderBy: "",
      processID: 1,

      filters: selectedCategory
        ? `{'SubCatID':${selectedCategory.SubCategoryID},'PriceContractID':${PriceID || 1},'ValidFrom': { $lte: ISODate('${end}') },'ValidTo': { $gte: ISODate('${start}') } }`
        : `{'PriceContractID':${PriceID || 1},'ValidFrom': { $lte: ISODate('${end}') },'ValidTo': { $gte: ISODate('${start}') }}`,
    };

    callApi(
      Url,
      itemBody,
      Authorization_Token ? Authorization_Token : staticToken,
      (data: any) => {
        if (data != null) {
          if (data?.hasErrors === false) {
            setItems(data?.response?.records || []);

            if (data?.response?.records?.length > 0) {
              getdataformItemMaster(
                data?.response?.records
                  ?.map((item: any) => item.ItemID)
                  .join(",") ?? "",
              );
            } else {
              setItems([]);
              setItemMasterData([]);
            }

            setLoading(false);
          } else {
            setLoading(false);
            console.log("Error in fetching categories", data);
          }
        } else {
          setLoading(false);
        }
      },
      (error: any) => {
        setLoading(false);
      },
    );
  };

  // const getdataformItemMaster = (data: any) => {
  //   let ids = data?.SubSubCategoryID;

  //   const filter =
  //     data != null ? `{SubSubCategoryID: { $in: [${ids}] }}` : `{}`;
  //   getRecords(1478, 100, -1, filter, 1, "", (data) => {
  //     // console.log("user details response", response);

  //     if (data != null) {
  //       if (data?.hasErrors === false) {
  //         setItemMasterData(data?.response?.records || []);

  //         setLoading(false);
  //       } else {
  //         setLoading(false);
  //         console.log("Error in fetching categories", data);
  //       }
  //     } else {
  //       setLoading(false);
  //     }
  //   });
  // };

  // const filteredProducts = products.filter(
  //   (product) =>
  //     selectedCategory === "All" || product.category === selectedCategory,
  // );

  // const sortedProducts = [...filteredProducts].sort((a, b) => {
  //   if (sortBy === "price-low") return a.price - b.price;
  //   if (sortBy === "price-high") return b.price - a.price;
  //   if (sortBy === "rating") return b.rating - a.rating;
  //   return 0;
  // });

  const handleQuantityChange = (productId: number, delta: number) => {
    setQuantities((prev) => {
      const currentQty = prev[productId] || 1;
      const newQty = Math.max(0, Math.min(10, currentQty + delta));

      updateCartItemQuantity(productId, newQty);

      if (newQty === 0) {
        const updated = { ...prev };
        delete updated[productId];
        return updated;
      }

      return {
        ...prev,
        [productId]: newQty,
      };
    });
  };

  const handleAddToCart = (product: any) => {
    const quantity = quantities[product.ItemID] || 1;

    addToCart({
      ItemID: product.ItemID,
      ContractID: product.PriceContractID || 1,
      Qty: quantity,
    });

    setNotification(`${quantity} x ${product.Item} added to cart!`);
    setTimeout(() => setNotification(""), 3000);

    setQuantities((prev) => ({ ...prev, [product.ItemID]: 1 }));
  };

  const handleCategorySelect = (category: any) => {
    setSelectedCategory(category);
    setIsCategoryDrawerOpen(false);
  };

  const CategoryButton = ({
    category,
    isSelected,
    onClick,
    showCount = true,
  }) => (
    <button
      onClick={() => onClick()}
      className={`w-full text-left px-4 py-3 rounded-lg transition-all duration-200 flex items-center justify-between cursor-pointer ${
        isSelected
          ? "bg-amber-600 text-white shadow-md"
          : "bg-white text-gray-700 hover:bg-amber-50 hover:text-amber-700 border border-gray-100"
      }`}
    >
      <span className="flex items-center gap-3">
        {/* {category.icon && (
          <span className={`w-8 h-8 flex items-center justify-center rounded-full ${isSelected ? 'bg-amber-500' : 'bg-amber-100'}`}>
            <i className={`${category.icon} ${isSelected ? 'text-white' : 'text-amber-600'}`}></i>
          </span>
        )} */}
        <span className="font-medium">{category.SubCategory}</span>
      </span>
      {showCount && category.ItemsCount !== undefined && (
        <span
          className={`text-sm px-2 py-0.5 rounded-full ${isSelected ? "bg-amber-500 text-white" : "bg-gray-100 text-gray-500"}`}
        >
          {category.ItemsCount}
        </span>
      )}
    </button>
  );

  return (
    <div className="min-h-screen bg-white">
      <Navbar />
      <section className="relative pt-20 pb-20 bg-gradient-to-br from-[#1A2B4A] to-[#00B8A9]">
        <div className="max-w-7xl mx-auto px-6">
          <h1 className="text-6xl md:text-5xl font-bold text-white mb-6 leading-tight">
            Products
          </h1>
        </div>
      </section>
      {notification && (
        <div className="fixed top-24 right-4 bg-green-600 text-white px-6 py-3 rounded-lg shadow-lg z-50">
          {notification}
        </div>
      )}

      {/* Mobile Category Drawer Overlay */}
      {isCategoryDrawerOpen && (
        <div
          className="fixed inset-0 bg-black/50 z-50 lg:hidden"
          onClick={() => setIsCategoryDrawerOpen(false)}
        />
      )}

      {/* Mobile Category Drawer */}
      <div
        className={`fixed inset-y-0 left-0 w-80 max-w-[85vw] bg-white z-50 transform transition-transform duration-300 ease-out lg:hidden ${
          isCategoryDrawerOpen ? "translate-x-0" : "-translate-x-full"
        }`}
      >
        <div className="flex flex-col h-full">
          <div className="flex items-center justify-between p-4 border-b border-gray-100">
            <h3 className="text-lg font-bold text-gray-900">Categories</h3>
            <button
              onClick={() => setIsCategoryDrawerOpen(false)}
              className="w-10 h-10 flex items-center justify-center rounded-full hover:bg-gray-100 cursor-pointer"
            >
              <i className="ri-close-line text-xl text-gray-600"></i>
            </button>
          </div>

          <div className="flex-1 overflow-y-auto p-4 space-y-2">
            {/* <CategoryButton
              category={{ name: 'All Products', icon: 'ri-apps-line', count: products.length }}
              isSelected={selectedCategory === 'All'}
              onClick={() => handleCategorySelect('All')}
            /> */}

            {Categories?.map((category) => (
              <CategoryButton
                key={category._id}
                category={category}
                isSelected={
                  selectedCategory?.SubCategoryID === category.SubCategoryID
                }
                onClick={() => handleCategorySelect(category)}
              />
            ))}
          </div>

          <div className="p-4 border-t border-gray-100">
            <button
              onClick={() => setIsCategoryDrawerOpen(false)}
              className="w-full py-3 bg-amber-600 text-white rounded-lg font-semibold hover:bg-amber-700 transition-colors cursor-pointer whitespace-nowrap"
            >
              Apply Filter
            </button>
          </div>
        </div>
      </div>

      <div className="pt-32 pb-20">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="mb-8">
            <p className="text-sm text-gray-500 mb-2">
              <Link to="/" className="hover:text-amber-600">
                Home
              </Link>{" "}
              / Products
            </p>
            <h1 className="text-4xl md:text-5xl font-bold text-gray-900">
              All Products
            </h1>
          </div>

          {/* Mobile Category Pills - Horizontal Scroll */}
          <div className="lg:hidden mb-6">
            <div className="flex items-center gap-3 overflow-x-auto pb-2 scrollbar-hide">
              <button
                onClick={() => setIsCategoryDrawerOpen(true)}
                className="flex-shrink-0 flex items-center gap-2 px-4 py-2.5 bg-gray-900 text-white rounded-full font-medium cursor-pointer whitespace-nowrap"
              >
                <i className="ri-filter-3-line"></i>
                Filter
              </button>

              {/* <button
                onClick={() => setSelectedCategory('All')}
                className={`flex-shrink-0 px-4 py-2.5 rounded-full font-medium transition-colors cursor-pointer whitespace-nowrap ${
                  selectedCategory === 'All'
                    ? 'bg-amber-600 text-white'
                    : 'bg-gray-100 text-gray-700 hover:bg-gray-200'
                }`}
              >
                All
              </button> */}

              <button
                onClick={() => setSelectedCategory(null)}
                className={`flex-shrink-0 flex items-center gap-2 px-4 py-2.5 rounded-full font-medium transition-colors cursor-pointer whitespace-nowrap ${
                  selectedCategory === null
                    ? "bg-amber-600 text-white"
                    : "bg-gray-100 text-gray-700 hover:bg-gray-200"
                }`}
              >
                <span className="flex items-center gap-2">{`${"All"}`}</span>
                <span className="text-sm">
                  {" "}
                  {`(${Categories?.map((c) => c.ItemsCount).reduce((a, b) => a + b, 0)})`}
                </span>
              </button>
              {Categories.map((category) => (
                <button
                  key={category._id}
                  onClick={() => setSelectedCategory(category)}
                  className={`flex-shrink-0 flex items-center gap-2 px-4 py-2.5 rounded-full font-medium transition-colors cursor-pointer whitespace-nowrap ${
                    selectedCategory?.SubCategoryID === category.SubCategoryID
                      ? "bg-amber-600 text-white"
                      : "bg-gray-100 text-gray-700 hover:bg-gray-200"
                  }`}
                >
                  <i className={category.icon}></i>
                  {`${category.SubCategory} (${category.ItemsCount})`}
                </button>
              ))}
            </div>
          </div>

          <div className="flex flex-col lg:flex-row gap-8">
            <aside className="hidden lg:block lg:w-72 flex-shrink-0">
              <div className="bg-gray-50 rounded-xl p-6 sticky top-24">
                <h3 className="text-lg font-bold text-gray-900 mb-4">
                  Categories
                </h3>

                <div className="space-y-2">
                  {/* <button
                    onClick={() => setSelectedCategory(null)}
                    className={`w-full text-left px-4 py-3 rounded-lg transition-colors ${
                      selectedCategory === null
                        ? "bg-amber-600 text-white"
                        : "bg-white text-gray-700 hover:bg-gray-100"
                    }`}
                  >
                    All Products
                  </button> */}

                  <button
                    //  key={category.id}
                    onClick={() => setSelectedCategory(null)}
                    className={`w-full text-left px-4 py-3 rounded-lg transition-colors flex items-center justify-between ${
                      selectedCategory === null
                        ? "bg-amber-600 text-white"
                        : "bg-white text-gray-700 hover:bg-gray-100"
                    }`}
                  >
                    <span className="flex items-center gap-2">{`${"All"}`}</span>
                    <span className="text-sm">
                      {" "}
                      {`(${Categories?.map((c) => c.ItemsCount).reduce((a, b) => a + b, 0)})`}
                    </span>
                  </button>

                  {Categories?.map((category) => (
                    <button
                      key={category.id}
                      onClick={() => setSelectedCategory(category)}
                      className={`w-full text-left px-4 py-3 rounded-lg transition-colors flex items-center justify-between ${
                        selectedCategory?.SubCategoryID ===
                        category.SubCategoryID
                          ? "bg-amber-600 text-white"
                          : "bg-white text-gray-700 hover:bg-gray-100"
                      }`}
                    >
                      <span className="flex items-center gap-2">
                        <i className={category.Pic}></i>
                        {category.SubCategory}
                      </span>
                      <span className="text-sm">({category.ItemsCount})</span>
                    </button>
                  ))}
                </div>
              </div>
            </aside>

            <div className="flex-1">
              <div className="flex flex-col sm:flex-row justify-between items-start sm:items-center gap-4 mb-8">
                <p className="text-gray-600">
                  Showing {ItemMasterData?.length} products
                </p>

                <select
                  value={sortBy}
                  onChange={(e) => setSortBy(e.target.value)}
                  className="px-4 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-amber-500"
                >
                  <option value="featured">Featured</option>
                  <option value="price-low">Price: Low to High</option>
                  <option value="price-high">Price: High to Low</option>
                  <option value="rating">Highest Rated</option>
                </select>
              </div>

              <div className="max-w-7xl mx-auto px-6">
                <div className="space-y-24">
                  {items?.map((product, index) => (
                    <div
                      key={product.ItemID}
                      className={`grid grid-cols-1 md:grid-cols-2 gap-12 items-center ${
                        index % 2 === 1 ? "md:flex-row-reverse" : ""
                      }`}
                    >
                      <div className={`${index % 2 === 1 ? "md:order-2" : ""}`}>
                        <div className="bg-[#F8F6F3] rounded-2xl p-8 h-96 flex items-center justify-center">
                          <img
                            src={
                              ItemMasterData?.find(
                                (item) => item.ItemID === product.ItemID,
                              )?.ItemPic ||
                              "https://dialerpstorageac.blob.core.windows.net/10417/36/2596/2.png"
                            }
                            alt={product.Item}
                            className="w-full h-full object-contain"
                          />
                        </div>
                      </div>

                      <div className={`${index % 2 === 1 ? "md:order-1" : ""}`}>
                        <h2 className="text-3xl font-bold text-[#2D3436] mb-4">
                          {" "}
                          {product.Item}
                        </h2>

                        <div className="mb-8">
                          <p className="text-sm text-gray-500 mb-2">
                            About this item
                          </p>
                          <div
                            className="text-lg font-normal text-gray-900 [&_ul]:list-disc [&_ul]:pl-5 [&_ol]:list-decimal [&_ol]:pl-5"
                            dangerouslySetInnerHTML={{
                              __html: ItemMasterData?.find(
                                (item) => item.ItemID === product.ItemID,
                              )?.ItemDescription,
                            }}
                          />
                        </div>
{/* 
                        <div className="mb-6">
                          <h3 className="text-lg font-bold text-[#2D3436] mb-3">
                            Key Features:
                          </h3>
                        </div> */}

                        <div className="flex items-center gap-3 mb-4">
                          {(() => {
                            const priceItem = items?.find(
                              (p) => p.ItemID === product.ItemID,
                            );

                            const item = ItemMasterData?.find(
                              (i) => i.ItemID === product.ItemID,
                            );

                            const caseRate = parseFloat(
                              priceItem?.DistributorCaseRate || "0",
                            );
                            const units = parseFloat(
                              priceItem?.ItemInCase || "0",
                            );

                            let unitPrice = 0;
                            let unitMrp = 0;

                            if (caseRate > 0 && units > 0) {
                              unitPrice = caseRate / units; // 304 / 40 = 7.6
                              unitMrp =
                                parseFloat(priceItem?.CaseMRP || "0") / units; // 400 / 40 = 10
                            } else {
                              unitPrice = parseFloat(item?.MRP || "0");
                              unitMrp = parseFloat(item?.MRP || "0");
                            }
                            return (
                              <>
                                <span className="text-1xl font-bold text-gray-900">
                                  ₹{unitPrice.toFixed(2)}
                                </span>

                                {unitMrp > unitPrice && (
                                  <span className="text-lg text-gray-400 line-through">
                                    ₹{unitMrp.toFixed(2)}
                                  </span>
                                )}
                              </>
                            );
                          })()}
                        </div>

                        <div className="flex items-center gap-4">
                          {isInCart(
                            product.ItemID,
                            product.PriceContractID,
                          ) && (
                            <div className="flex items-center gap-2 bg-white border border-gray-200 rounded-full px-2 py-1">
                              <button
                                onClick={() =>
                                  handleQuantityChange(product.ItemID, -1)
                                }
                                className="w-9 h-9 bg-gray-100 rounded-full flex items-center justify-center hover:bg-gray-200 transition-colors cursor-pointer"
                              >
                                <i className="ri-subtract-line text-lg text-gray-700"></i>
                              </button>
                              <span className="w-8 text-center text-lg font-semibold text-gray-900">
                                {getCartQuantity(
                                  product.ItemID,
                                  product.PriceContractID,
                                )}
                              </span>
                              <button
                                onClick={() =>
                                  handleQuantityChange(product.ItemID, 1)
                                }
                                className="w-9 h-9 bg-gray-100 rounded-full flex items-center justify-center hover:bg-gray-200 transition-colors cursor-pointer"
                              >
                                <i className="ri-add-line text-lg text-gray-700"></i>
                              </button>
                            </div>
                          )}

                          {!isInCart(
                            product.ItemID,
                            product.PriceContractID,
                          ) && (
                            <button
                              onClick={() => {
                                !isInCart(
                                  product.ItemID,
                                  product.PriceContractID,
                                )
                                  ? handleAddToCart(product)
                                  : navigate("/cart");
                              }}
                              className="flex-1 py-3 bg-gray-700 text-white rounded-xl font-semibold hover:bg-gray-800 transition-colors whitespace-nowrap cursor-pointer text-1xl"
                            >
                              {"Add"}
                            </button>
                          )}
                        </div>
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <Footer />
    </div>
  );
}
